import { Stack, Typography, TypographyType as TypographyProps } from '@lyearn/ui';

interface TypographyWithBulletPointProps extends Omit<TypographyProps, 'children'> {
  text: string;
}

export const TypographyWithBulletPoint = ({
  text,
  ...typographyProps
}: TypographyWithBulletPointProps) => {
  return (
    <Stack alignItems="start" gapX={12}>
      <Typography {...typographyProps}>•</Typography>
      <Typography {...typographyProps}>{text}</Typography>
    </Stack>
  );
};
